
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2023
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'createDashboardTitle': 'Créer un tableau de bord',
	'dashboard': 'Tableau de bord',
	'dashboardTemplate': 'Modèle de tableau de bord',
	'createAV': 'Créer',
	'createAvEditNameLabel': '1. Donnez un nom à votre vue',
	'createAvSelectTemplateLabel': '2. Sélectionnez un modèle',
	'tabLayoutLabel': 'Modèle à onglets',
	'infographicsLayoutLabel': 'Modèle infographique',
	'singlePageLayoutLabel': 'Modèle sur une seule page',
	'customLayoutLabel': 'Modèle personnalisé',
	'freeformTemplate': 'Format libre',
	'freeformTemplateDesc': 'Les visualisations avec la présentation Format libre apparaissent avec la taille et à l\'endroit que vous avez choisis dans la vue, quelle que soit la taille de l\'écran. Dans les autres présentations, la taille et la position des visualisation s\'ajustent à l\'écran.',
	'NoTemplate': 'Format libre',
	'Template1': 'Rapport vierge',
	'Template2': 'Titre 1 par 2',
	'Template3': '2 sur 1',
	'Template4': '4 sur 1',
	'Template5': 'Pied de page 1 par 2',
	'Template6': '3 à côté de 1 sur 1',
	'Template7': '4 à côté de 3 sur 1',
	'Template8': '2 sur 3 par 2',
	'Template9': '2 par 2',
	'Template10': '1 par 2 à côté de 2 par 2 sur 1',
	'Template11': '3 par 1 sur 1 par 2',
	'Template12': '2 sur 1 à côté de 1 par 2',
	'Template13': '1 à côté de 1 par 2 à côté de 1 par 4',
	'Template22': '1 sur 2 par 2',
	'Template14': '1 en regard de 1',
	'Template15': '1 sur 1 en regard de 1',
	'Template16': '1 en regard de 1 sur 1',
	'Template17': '1 sur 1 en regard de 1 sur 1',
	'Template18': '1 sur 1 en regard de 1',
	'Template19': '1 sur 2 en regard de 1',
	'Template20': '1 sur 2 par 1',
	'Template21': '1 sur 1 sur 2 par 1',
	'Template23': 'Vierge avec zone d\'insertion',
	'Infographics1': 'Rapport vierge',
	'Infographics2': '4 lignes',
	'Infographics3': '4 lignes avec en-têtes',
	'Infographics4': '2 par 4',
	'Infographics5': 'Grande partie supérieure avec 2 par 2',
	'Infographics6': '2 par 4 avec écart vertical',
	'Infographics7': '2 par 4 décalé',
	'Infographics8': 'Cours de tennis',
	'Infographics9': '3 par 4',
	'Infographics10': '4 par 8',
	'createAvDashboardLabel': 'Présentation',
	'dashboard_template_save_success': 'Votre modèle de tableau de bord a été sauvegardé.',
	'dashboard_template_prefix': 'Modèle : "%{name}"',
	'dashboard_template_filters_removed': 'Les filtres du canevas ont été supprimés.',
	'createAvTabLabel': 'Avec onglets',
	'createAvInfographicsLabel': 'Infographie',
	'createAvSinglepageLabel': 'Une seule page',
	'createAvCustomLabel': 'Personnalisé',
	'loadMoreLabel': 'Charger plus...',
	'backLabel': 'Revenir en arrière',
	'addSourceLabel': 'Ajouter une source',
	'pinLabel': 'Epingler',
	'errorLoadingDataSetMetaData': 'Une erreur est survenue lors de la lecture des métadonnées.',
	'errorLoadingDataSets': 'Une erreur est survenue lors du chargement de la liste des ensembles de données',
	'errorLoadingDataSet': 'Le chargement des métadonnées de l\'ensemble de données "%{datasetName}" a échoué. Prenez contact avec votre administrateur pour des détails.',
	'okButton': 'OK',
	'createButton': 'Créer',
	'cancelButton': 'Annuler',
	'copyButton': 'Copier',
	'selectTemplateLabel': 'Sélectionner un modèle',
	'createBoardTitle': 'Créer un tableau de bord',
	'createBoardSubtitle': 'Sélectionner un modèle pour votre tableau de bord',
	'noSourcesSelectedLabel': 'Aucune source sélectionnée',
	'find_label': 'Rechercher',
	'noDashboardFound': 'Impossible d\'extraire le tableau de bord. Elle n\'existe plus ou vous ne disposez pas de privilèges suffisants pour l\'afficher.',
	'errorLabel': 'Erreur',
	'defaultName': 'Nouveau tableau de bord',
	'noDashboardCapability': 'Vous ne disposez pas du droit permettant d\'exécuter l\'application de tableau de bord.',
	'noCapabilityForCreateDashboard': 'Vous n\'êtes pas autorisé à créer un tableau de bord pour les actifs sélectionnés',
	'noCapabilityForEdit': 'Vous n\'avez pas la possibilité de modifier ce tableau de bord',
	'noCapabilityForSave': 'Vous n\'avez pas la possibilité de sauvegarder ce tableau de bord',
	'noCapabilityForPaste': 'Vous n\'avez pas la possibilité de coller des widgets copiés dans cette vue',
	'noCapabilityForPin': 'Vous n\'avez pas la possibilité d\'ajouter cette épingle',
	'noCapabilityForLaunchInExplore': 'Vous n\'avez pas la possibilité de lancer des widgets copiés dans une exploration',
	'noDashboardPermission': 'Vous ne disposez pas de privilèges suffisants pour afficher ce tableau de bord.',
	'sourceNotFound': 'Impossible de charger la visualisation, car la source "%{sourceName}" associée n\'est pas disponible',
	'cmDuplicateName': 'Un élément de ce nom existe déjà. Essayez un autre nom.',
	'cmEmptySelection': 'Le tableau de bord a été supprimé. Tentez de procéder à la sauvegarde sous un nouveau tableau de bord.',
	'propTheme_v1': 'Thème visuel',
	'propTheme': 'Thème',
	'legacyThemeLabel': 'Existant',
	'carbonGrey10Label': 'Carbon X clair',
	'carbonGrey100Label': 'Carbon X foncé',
	'titleTextLabel': 'Titre',
	'titleSmallTextLabel': 'Petit titre',
	'subtitleTextLabel': 'Sous-titre',
	'bodyTextLabel': 'Corps',
	'bodySmallTextLabel': 'Petit corps',
	'captionTextLabel': 'Légende',
	'quoteTextLabel': 'Apostrophe',
	'quoteSmallTextLabel': 'Petite apostrophe',
	'responsiveTextLabel': 'Dimensionnement automatique',
	'mediaWidgetLabel': 'Supports',
	'webpageWidgetLabel': 'Page Web',
	'imageWidgetLabel': 'Image',
	'textWidgetLabel': 'Texte',
	'notebookWidgetLabel': 'Bloc-notes',
	'multipurposeWidgetLabel': 'Multi-usage',
	'textPlaceHolder': 'Cliquez pour éditer le texte',
	'titlePlaceHolder': 'Cliquer pour éditer le titre',
	'toggleEditModeLabel': 'Passer à l\'édition',
	'togglePreviewModeLabel': 'Passer à l\'aperçu',
	'editDashboardCoachMarkTitle': 'Editer le tableau de bord',
	'editDashboardCoachMarkContents': 'Cliquez sur l\'icône Crayon pour éditer ce tableau de bord.',
	'addDataCoachMarkTitle': 'Ajouter des données',
	'addDataDashboardCoachMarkContents': 'Faites glisser des données du panneau des données jusqu\'à votre tableau de bord.',
	'pageSelectWarning': 'Sélectionnez un onglet.',
	'screenshot_label': 'Tableau de bord %{title}',
	'screenshot_label_tab': 'Onglet %{tabName} du tableau de bord %{title}',
	'dataAssetPropertiesLabel': 'Propriétés de visualisation',
	'modelFilter': 'Filtre',
	'invertSelectionToolTip': 'Inverser les sélections de filtre',
	'clearFilterValueToolTip': 'Effacer les valeurs de filtre',
	'invertFilterSelection': 'Inverser',
	'clearTextFilterValue': 'Effacer',
	'filterConditionLabel': 'Condition de filtre',
	'applyFilter': 'Appliquer le filtre',
	'itemCountText': '%{itemCount} élément(s) sélectionné(s)',
	'itemExcludeCountText': '%{itemCount} élément(s) exclu(s)',
	'moreMembers': 'Afficher plus...',
	'searchHierarchyMembers': 'Utiliser la fonction de recherche pour rechercher des membres...',
	'propHideEmpty': 'Masquer vide',
	'propColorOrder': 'Ordre des couleurs',
	'propElementColor': 'Couleur de l\'élément de la visualisation',
	'propLineColor': 'Couleur du trait',
	'propLineAndSymbolColor': 'Couleur des lignes et des symboles',
	'propColumnColor': 'Couleur de la colonne',
	'propBarColor': 'Couleur des barres',
	'propWordColor': 'Couleur des mots',
	'propAreaColor': 'Couleur de la zone',
	'propRadialbarColor': 'Couleur de la barre radiale',
	'propColorPalettes': 'Palettes de couleurs',
	'propDashboardColorPalette': 'Palette de tableaux de bord actuelle',
	'propNewDashboardPaletteLabel': 'Création d\'une palette de tableaux de bord personnalisée',
	'propDashboardChangePaletteLink': 'Modifier la palette de tableaux de bord',
	'propHideLeafNode': 'Masquer les libellés des feuilles',
	'propOpacity_v1': 'Opacité du widget',
	'propOpacity': 'Opacité du widget (%)',
	'propOpacityDescription': 'Rendez l\'objet plus ou moins opaque. Entrez une valeur comprise entre 0 et 100.',
	'addATab': 'Ajouter un nouvel onglet',
	'propFredIsRed': 'Uniformité des couleurs',
	'areaChartCaption': 'Aire',
	'areaChartDataSlot_categoriesLabel': 'Libellé de l\'axe',
	'areaChartDataSlot_valuesLabel': 'Valeur',
	'areaChartProp_colorPaletteLabel': 'Palettes de couleurs',
	'areaChartProp_lineColorLabel': 'Couleur de la zone',
	'areaChartProp_interpolationLabel': 'Courbes lisses',
	'areaChartProp_interpolationDescription': 'Les courbes connectant les points de données sont arrondies.',
	'areaChartProp_hideGridLinesLabel': 'Masquer le quadrillage',
	'areaChartProp_hideGridLinesDescription': 'Masquer le quadrillage',
	'areaChartProp_hideAxisTitleLabelsLabel': 'Masquer les libellés des titres des axes',
	'areaChartProp_hideAxisTitleLabelsDescription': 'Masquer les titres des axes.',
	'areaChartProp_maintainAxisScalesLabel': 'Maintenir l\'échelle de l\'axe',
	'areaChartProp_maintainAxisScalesDescription': 'Afficher toujours les valeurs minimales et maximales des axes.',
	'areaChartProp_suppressZerosLabel': 'Masquer vide',
	'areaChartProp_suppressZerosDescription': 'Masquer les catégories sans valeurs associées.',
	'barChartCaption': 'Barres',
	'barChartDataSlot_categoriesLabel': 'Libellé de l\'axe',
	'barChartDataSlot_valuesLabel': 'Valeur',
	'barChartProp_colorPaletteLabel': 'Palettes de couleurs',
	'barChartProp_elementColorLabel': 'Couleur des barres',
	'barChartProp_hideGridLinesLabel': 'Masquer le quadrillage',
	'barChartProp_hideGridLinesDescription': 'Masquer le quadrillage',
	'barChartProp_hideAxisTitleLabelsLabel': 'Masquer les libellés des titres des axes',
	'barChartProp_hideAxisTitleLabelsDescription': 'Masquer les titres des axes.',
	'barChartProp_maintainAxisScalesLabel': 'Maintenir l\'échelle de l\'axe',
	'barChartProp_maintainAxisScalesDescription': 'Afficher toujours les valeurs minimales et maximales des axes.',
	'barChartProp_suppressZerosLabel': 'Masquer vide',
	'barChartProp_suppressZerosDescription': 'Masquer les catégories sans valeurs associées.',
	'columnChartCaption': 'Colonne',
	'columnChartDataSlot_categoriesLabel': 'Libellé de l\'axe',
	'columnChartDataSlot_valuesLabel': 'Valeur',
	'columnChartProp_colorPaletteLabel': 'Palettes de couleurs',
	'columnChartProp_elementColorLabel': 'Couleur de la colonne',
	'columnChartProp_hideGridLinesLabel': 'Masquer le quadrillage',
	'columnChartProp_hideGridLinesDescription': 'Masquer le quadrillage',
	'columnChartProp_hideAxisTitleLabelsLabel': 'Masquer les libellés des titres des axes',
	'columnChartProp_hideAxisTitleLabelsDescription': 'Masquer les titres des axes.',
	'columnChartProp_maintainAxisScalesLabel': 'Maintenir l\'échelle de l\'axe',
	'columnChartProp_maintainAxisScalesDescription': 'Afficher toujours les valeurs minimales et maximales des axes.',
	'columnChartProp_suppressZerosLabel': 'Masquer vide',
	'columnChartProp_suppressZerosDescription': 'Masquer les catégories sans valeurs associées.',
	'bubbleChartCaption': 'Bulles',
	'bubbleChartDataSlot_xAxisLabel': 'Axe horizontal',
	'bubbleChartDataSlot_yAxisLabel': 'Axe vertical',
	'bubbleChartDataSlot_sizeLabel': 'Taille selon',
	'bubbleChartDataSlot_colorLabel': 'Couleur selon',
	'bubbleChartProp_colorPaletteLabel': 'Palettes de couleurs',
	'bubbleChartProp_hideGridLinesLabel': 'Masquer le quadrillage',
	'bubbleChartProp_hideGridLinesDescription': 'Masquer le quadrillage',
	'bubbleChartProp_hideAxisTitleLabelsLabel': 'Masquer les libellés des titres des axes',
	'bubbleChartProp_hideAxisTitleLabelsDescription': 'Masquer les titres des axes.',
	'bubbleChartProp_maintainAxisScalesLabel': 'Maintenir l\'échelle de l\'axe',
	'bubbleChartProp_maintainAxisScalesDescription': 'Afficher toujours les valeurs minimales et maximales des axes.',
	'bubbleChartProp_hideLegendLabel': 'Masquer la légende',
	'bubbleChartProp_hideLegendDescription': 'Masquer la légende.',
	'bubbleChartProp_legendPositionLabel': 'Position de la légende',
	'lineChartCaption': 'Courbe',
	'lineChartDataSlot_categoriesLabel': 'Libellé de l\'axe',
	'lineChartDataSlot_valuesLabel': 'Valeur',
	'lineChartProp_colorPaletteLabel': 'Palettes de couleurs',
	'lineChartProp_lineColorLabel': 'Couleur des lignes et des symboles',
	'lineChartProp_symbolShapeLabel': 'Forme du symbole',
	'lineChartProp_hideSymbolsLabel': 'Masquer les symboles',
	'lineChartProp_hideSymbolsDescription': 'Masquer les symboles',
	'lineChartProp_hideDataLinesLabel': 'Masquer les lignes',
	'lineChartProp_hideDataLinesDescription': 'Masquer les lignes',
	'lineChartProp_interpolationLabel': 'Courbes lisses',
	'lineChartProp_interpolationDescription': 'Les courbes connectant les points de données sont arrondies.',
	'lineChartProp_hideGridLinesLabel': 'Masquer le quadrillage',
	'lineChartProp_hideGridLinesDescription': 'Masquer le quadrillage',
	'lineChartProp_hideAxisTitleLabelsLabel': 'Masquer les libellés des titres des axes',
	'lineChartProp_hideAxisTitleLabelsDescription': 'Masquer les titres des axes.',
	'lineChartProp_maintainAxisScalesLabel': 'Maintenir l\'échelle de l\'axe',
	'lineChartProp_maintainAxisScalesDescription': 'Afficher toujours les valeurs minimales et maximales des axes.',
	'lineChartProp_suppressZerosLabel': 'Masquer vide',
	'lineChartProp_suppressZerosDescription': 'Masquer les catégories sans valeurs associées.',
	'packedBubbleChart1CatCaption': 'Paquet de bulles',
	'packedBubbleChart1CatDataSlot_categoriesLabel': 'Catégories',
	'packedBubbleChart1CatDataSlot_sizeLabel': 'Taille selon',
	'packedBubbleChart1CatProp_colorPaletteLabel': 'Palettes de couleurs',
	'packedBubbleChart1CatProp_elementColorLabel': 'Couleur de bulle',
	'packedBubbleChart1CatProp_hideLabelLabel': 'Masquer le libellé',
	'packedBubbleChart1CatProp_hideValueLabel': 'Masquer la valeur',
	'packedBubbleChart1CatProp_maintainAxisScalesLabel': 'Maintenir l\'échelle de l\'axe',
	'packedBubbleChart1CatProp_maintainAxisScalesDescription': 'Afficher toujours les valeurs minimales et maximales des axes.',
	'packedBubbleChart1CatProp_suppressZerosLabel': 'Masquer vide',
	'packedBubbleChart1CatProp_suppressZerosDescription': 'Masquer les catégories sans valeurs associées.',
	'heatChartCaption': 'Densité',
	'heatChartDataSlot_valuesLabel': 'Densité selon',
	'heatChartDataSlot_xAxisLabel': 'Axe horizontal',
	'heatChartDataSlot_yAxisLabel': 'Axe vertical',
	'heatChartProp_colorPaletteLabel': 'Palettes de couleurs',
	'heatChartProp_heatScalePaletteLabel': 'Ordre des couleurs',
	'heatChartProp_hideAxisTitleLabelsLabel': 'Masquer les libellés des titres des axes',
	'heatChartProp_hideAxisTitleLabelsDescription': 'Masquer les titres des axes.',
	'heatChartProp_maintainAxisScalesLabel': 'Maintenir l\'échelle de l\'axe',
	'heatChartProp_maintainAxisScalesDescription': 'Afficher toujours les valeurs minimales et maximales des axes.',
	'heatChartProp_suppressZerosLabel': 'Masquer vide',
	'heatChartProp_suppressZerosDescription': 'Masquer les catégories sans valeurs associées.',
	'heatChartProp_hideLegendLabel': 'Masquer la légende',
	'heatChartProp_hideLegendDescription': 'Masquer la légende.',
	'heatChartProp_legendPositionLabel': 'Position de la légende',
	'pieChartCaption': 'Circulaire',
	'pieChartDataSlot_categoriesLabel': 'Catégories',
	'pieChartDataSlot_valuesLabel': 'Valeur',
	'pieChartProp_colorPaletteLabel': 'Palettes de couleurs',
	'pieChartProp_hideRadialValueLabel': 'Masquer la valeur',
	'pieChartProp_pieAsDonutLabel': 'Afficher sous forme de graphique en anneau',
	'pieChartProp_pieAsDonutDescription': 'Afficher sous forme de graphique en anneau',
	'pieChartProp_suppressZerosLabel': 'Masquer vide',
	'pieChartProp_suppressZerosDescription': 'Masquer les catégories sans valeurs associées.',
	'pieChartProp_hideLegendLabel': 'Masquer la légende',
	'pieChartProp_hideLegendDescription': 'Masquer la légende.',
	'pieChartProp_legendPositionLabel': 'Position de la légende',
	'map1measureCaption': 'Carte',
	'map1measureDataSlot_categoriesLabel': 'Régions',
	'map1measureDataSlot_valuesLabel': 'Densité de région',
	'map1measureProp_colorPaletteLabel': 'Palettes de couleurs',
	'map1measureProp_heatScalePaletteLabel': 'Ordre des couleurs',
	'map1measureProp_maintainAxisScalesLabel': 'Maintenir l\'échelle de l\'axe',
	'map1measureProp_maintainAxisScalesDescription': 'Afficher toujours les valeurs minimales et maximales des axes.',
	'map1measureProp_suppressZerosLabel': 'Masquer vide',
	'map1measureProp_suppressZerosDescription': 'Masquer les catégories sans valeurs associées.',
	'map1measureProp_hideLegendLabel': 'Masquer la légende',
	'map1measureProp_hideLegendDescription': 'Masquer la légende.',
	'map1measureProp_legendPositionLabel': 'Position de la légende',
	'radialChartCaption': 'Radial',
	'radialChartDataSlot_categoriesLabel': 'Catégories',
	'radialChartDataSlot_valuesLabel': 'Valeur',
	'radialChartProp_colorPaletteLabel': 'Palettes de couleurs',
	'radialChartProp_elementColorLabel': 'Couleur de la barre radiale',
	'radialChartProp_hideRadialTitleLabel': 'Masquer le titre',
	'radialChartProp_hideRadialValueLabel': 'Masquer la valeur',
	'radialChartProp_maintainAxisScalesLabel': 'Maintenir l\'échelle de l\'axe',
	'radialChartProp_maintainAxisScalesDescription': 'Afficher toujours les valeurs minimales et maximales des axes.',
	'radialChartProp_suppressZerosLabel': 'Masquer vide',
	'radialChartProp_suppressZerosDescription': 'Masquer les catégories sans valeurs associées.',
	'pointChart1catCaption': 'Points',
	'pointChart1catDataSlot_valuesLabel': 'Valeur',
	'pointChart1catDataSlot_categoriesLabel': 'Libellé de l\'axe',
	'pointChart1catProp_colorPaletteLabel': 'Palettes de couleurs',
	'pointChart1catProp_elementColorLabel': 'Couleur de la forme',
	'pointChart1catProp_symbolShapeLabel': 'Forme du symbole',
	'pointChart1catProp_symbolFillLabel': 'Remplir la forme',
	'pointChart1catProp_symbolFillDescription': 'Afficher la couleur de remplissage pour les symboles.',
	'pointChart1catProp_hideGridLinesLabel': 'Masquer le quadrillage',
	'pointChart1catProp_hideGridLinesDescription': 'Masquer le quadrillage',
	'pointChart1catProp_hideAxisTitleLabelsLabel': 'Masquer les libellés des titres des axes',
	'pointChart1catProp_hideAxisTitleLabelsDescription': 'Masquer les titres des axes.',
	'pointChart1catProp_maintainAxisScalesLabel': 'Maintenir l\'échelle de l\'axe',
	'pointChart1catProp_maintainAxisScalesDescription': 'Afficher toujours les valeurs minimales et maximales des axes.',
	'pointChart1catProp_suppressZerosLabel': 'Masquer vide',
	'pointChart1catProp_suppressZerosDescription': 'Masquer les catégories sans valeurs associées.',
	'scatterPlotChartNoCatCaption': 'Nuage de points',
	'scatterPlotChartNoCatDataSlot_xAxisLabel': 'Axe horizontal',
	'scatterPlotChartNoCatDataSlot_yAxisLabel': 'Axe vertical',
	'scatterPlotChartNoCatProp_colorPaletteLabel': 'Palettes de couleurs',
	'scatterPlotChartNoCatProp_elementColorLabel': 'Couleur de l\'élément',
	'scatterPlotChartNoCatProp_symbolShapeLabel': 'Forme du symbole',
	'scatterPlotChartNoCatProp_symbolFillLabel': 'Remplir la forme',
	'scatterPlotChartNoCatProp_symbolFillDescription': 'Afficher la couleur de remplissage pour les symboles.',
	'scatterPlotChartNoCatProp_hideGridLinesLabel': 'Masquer le quadrillage',
	'scatterPlotChartNoCatProp_hideGridLinesDescription': 'Masquer le quadrillage',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsLabel': 'Masquer les libellés des titres des axes',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsDescription': 'Masquer les titres des axes.',
	'radialBarChartCaption': 'Barres radiales',
	'radialBarChartDataSlot_categoriesLabel': 'Catégories',
	'radialBarChartDataSlot_valuesLabel': 'Valeur',
	'radialBarChartProp_colorPaletteLabel': 'Palettes de couleurs',
	'radialBarChartProp_elementColorLabel': 'Couleur de la barre radiale',
	'radialBarChartProp_hideRadialTitleLabel': 'Masquer le titre',
	'radialBarChartProp_maintainAxisScalesLabel': 'Maintenir l\'échelle de l\'axe',
	'radialBarChartProp_maintainAxisScalesDescription': 'Afficher toujours les valeurs minimales et maximales des axes.',
	'radialBarChartProp_suppressZerosLabel': 'Masquer vide',
	'radialBarChartProp_suppressZerosDescription': 'Masquer les catégories sans valeurs associées.',
	'lineColumnComboChartCaption': 'Courbe et colonne',
	'lineColumnComboChartDataSlot_categoryLabel': 'Libellé de l\'axe',
	'lineColumnComboChartDataSlot_lineValueLabel': 'Valeur de la courbe',
	'lineColumnComboChartDataSlot_columnValueLabel': 'Valeur de la colonne',
	'lineColumnComboChartProp_colorPaletteLabel': 'Palettes de couleurs',
	'lineColumnComboChartProp_elementColorLabel': 'Couleur de la colonne',
	'lineColumnComboChartProp_lineColorLabel': 'Couleur des lignes et des symboles',
	'lineColumnComboChartProp_symbolShapeLabel': 'Forme du symbole',
	'lineColumnComboChartProp_hideSymbolsLabel': 'Masquer les symboles',
	'lineColumnComboChartProp_hideSymbolsDescription': 'Masquer les symboles',
	'lineColumnComboChartProp_hideDataLinesLabel': 'Masquer les lignes',
	'lineColumnComboChartProp_hideDataLinesDescription': 'Masquer les lignes',
	'lineColumnComboChartProp_interpolationLabel': 'Courbes lisses',
	'lineColumnComboChartProp_interpolationDescription': 'Les courbes connectant les points de données sont arrondies.',
	'lineColumnComboChartProp_hideGridLinesLabel': 'Masquer le quadrillage',
	'lineColumnComboChartProp_hideGridLinesDescription': 'Masquer le quadrillage',
	'lineColumnComboChartProp_hideAxisTitleLabelsLabel': 'Masquer les libellés des titres des axes',
	'lineColumnComboChartProp_hideAxisTitleLabelsDescription': 'Masquer les titres des axes.',
	'lineColumnComboChartProp_maintainAxisScalesLabel': 'Maintenir l\'échelle de l\'axe',
	'lineColumnComboChartProp_maintainAxisScalesDescription': 'Afficher toujours les valeurs minimales et maximales des axes.',
	'lineColumnComboChartProp_suppressZerosLabel': 'Masquer vide',
	'lineColumnComboChartProp_suppressZerosDescription': 'Masquer les catégories sans valeurs associées.',
	'lineColumnComboChartProp_hideLegendLabel': 'Masquer la légende',
	'lineColumnComboChartProp_hideLegendDescription': 'Masquer la légende.',
	'lineColumnComboChartProp_legendPositionLabel': 'Position de la légende',
	'summaryCaption': 'Récapitulatif',
	'areaName': 'Aire',
	'areaDescription': 'Aire',
	'areaDataSlot_colorLabel': 'Couleur selon',
	'areaDataSlot_valuesLabel': 'Valeur',
	'areaDataSlot_categoriesLabel': 'Libellé de l\'axe',
	'bubbleName': 'Bulles',
	'bubbleDescription': 'Bulles',
	'bubbleDataSlot_yAxisLabel': 'Axe vertical',
	'bubbleDataSlot_xAxisLabel': 'Axe horizontal',
	'bubbleDataSlot_sizeLabel': 'Taille selon',
	'bubbleDataSlot_colorLabel': 'Couleur selon',
	'clusterBarName': 'Barres',
	'clusterBarDescription': 'Barres',
	'clusterBarDataSlot_colorLabel': 'Couleur selon',
	'clusterBarDataSlot_valuesLabel': 'Valeur',
	'clusterBarDataSlot_categoriesLabel': 'Libellé de l\'axe',
	'clusterBarDataSlot_valuesRepeatingLabel': 'Valeur',
	'clusterColumnName': 'Colonne',
	'clusterColumnDescription': 'Colonne',
	'clusterColumnDataSlot_colorLabel': 'Couleur selon',
	'clusterColumnDataSlot_valuesLabel': 'Valeur',
	'clusterColumnDataSlot_categoriesLabel': 'Libellé de l\'axe',
	'clusterColumnDataSlot_valuesRepeatingLabel': 'Valeur',
	'clusterLineName': 'Courbe',
	'clusterLineDescription': 'Courbe',
	'clusterLineDataSlot_colorLabel': 'Couleur selon',
	'clusterLineDataSlot_valuesLabel': 'Axe vertical',
	'clusterLineDataSlot_categoriesLabel': 'Axe horizontal',
	'clusterLineDataSlot_valuesRepeatingLabel': 'Valeur',
	'gridName': 'Grille',
	'gridDescription': 'Grille',
	'gridDataSlot_grid_colsLabel': 'Colonne',
	'heatName': 'Densité',
	'heatDescription': 'Densité',
	'heatDataSlot_yAxisLabel': 'Axe vertical',
	'heatDataSlot_xAxisLabel': 'Axe horizontal',
	'heatDataSlot_valuesLabel': 'Densité selon',
	'lineColumnComboName': 'Courbe et colonne',
	'lineColumnComboDescription': 'Courbe et colonne',
	'lineColumnComboDataSlot_lineValueLabel': 'Valeur de la courbe',
	'lineColumnComboDataSlot_categoryLabel': 'Libellé de l\'axe',
	'lineColumnComboDataSlot_columnValueLabel': 'Valeur de la colonne',
	'mapName': 'Carte existante',
	'mapDescription': 'Carte existante',
	'mapDataSlot_sizeLabel': 'Taille des points',
	'mapDataSlot_valuesLabel': 'Densité de région',
	'mapDataSlot_sizeHeatLabel': 'Densité des points',
	'mapDataSlot_categoriesLabel': 'Régions',
	'packedBubbleName': 'Paquet de bulles',
	'packedBubbleDescription': 'Paquet de bulles',
	'packedBubbleDataSlot_sizeLabel': 'Taille selon',
	'packedBubbleDataSlot_colorLabel': 'Couleur selon',
	'packedBubbleDataSlot_categoriesLabel': 'Catégories',
	'pieName': 'Circulaire',
	'pieDescription': 'Circulaire',
	'pieDataSlot_valuesLabel': 'Valeur',
	'pieDataSlot_categoriesLabel': 'Catégories',
	'playerName': 'Lecteur de données',
	'playerDescription': 'Lecteur de données',
	'playerDataSlot_categoriesLabel': 'Libellé de l\'axe',
	'pointName': 'Points',
	'pointDescription': 'Points',
	'pointDataSlot_colorLabel': 'Couleur selon',
	'pointDataSlot_valuesLabel': 'Valeur',
	'pointDataSlot_categoriesLabel': 'Libellé de l\'axe',
	'radialName': 'Radial',
	'radialDescription': 'Radial',
	'radialDataSlot_valuesLabel': 'Valeur',
	'radialDataSlot_maxSizeLabel': 'Valeur maximale',
	'radialDataSlot_categoriesLabel': 'Catégories',
	'radialBarName': 'Barres radiales',
	'radialBarDescription': 'Barres radiales',
	'radialBarDataSlot_valuesLabel': 'Valeur',
	'radialBarDataSlot_categoriesLabel': 'Catégories',
	'scatterPlotName': 'Nuage de points',
	'scatterPlotDescription': 'Nuage de points',
	'scatterPlotDataSlot_yAxisLabel': 'Axe vertical',
	'scatterPlotDataSlot_xAxisLabel': 'Axe horizontal',
	'scatterPlotDataSlot_colorLabel': 'Couleur selon',
	'scatterPlotDataSlot_categoriesLabel': 'Points',
	'stackedBarName': 'Barres empilées',
	'stackedBarDescription': 'Barres empilées',
	'stackedBarDataSlot_colorLabel': 'Couleur selon',
	'stackedBarDataSlot_valuesLabel': 'Valeur',
	'stackedBarDataSlot_categoriesLabel': 'Libellé de l\'axe',
	'stackedBarDataSlot_valuesRepeatingLabel': 'Valeur',
	'stackedColumnName': 'Colonnes empilées',
	'stackedColumnDescription': 'Colonnes empilées',
	'stackedColumnDataSlot_colorLabel': 'Couleur selon',
	'stackedColumnDataSlot_valuesLabel': 'Valeur',
	'stackedColumnDataSlot_categoriesLabel': 'Libellé de l\'axe',
	'stackedColumnDataSlot_valuesRepeatingLabel': 'Valeur',
	'summaryChartName': 'Récapitulatif',
	'summaryChartDescription': 'Récapitulatif',
	'summaryChartDataSlot_valuesLabel': 'Valeur',
	'treeMapName': 'Carte d\'arborescence',
	'treeMapDescription': 'Carte d\'arborescence',
	'treeMapDataSlot_colorLabel': 'Densité selon',
	'treeMapDataSlot_valuesLabel': 'Taille selon',
	'treeMapDataSlot_categoriesLabel': 'Niveau un',
	'treeMapDataSlot_level3Label': 'Niveau trois',
	'treeMapDataSlot_level2Label': 'Niveau deux',
	'wordCloudName': 'Nuage de mots',
	'wordCloudDescription': 'Nuage de mots',
	'wordCloudDataSlot_colorLabel': 'Couleur selon',
	'wordCloudDataSlot_scaleLabel': 'Taille selon',
	'wordCloudDataSlot_wordLabel': 'Mots',
	'treeMap1Cat1MeasureChartCaption': 'Carte d\'arborescence',
	'treeMap1Cat1MeasureChartDataSlot_categoriesLabel': 'Niveau un',
	'treeMap1Cat1MeasureChartDataSlot_valuesLabel': 'Taille selon',
	'treeMap1Cat1MeasureChartProp_colorPaletteLabel': 'Palettes de couleurs',
	'treeMap1Cat2MeasureChartProp_colorPaletteLabel': 'Palettes de couleurs',
	'treeMap2Cat1MeasureChartProp_colorPaletteLabel': 'Palettes de couleurs',
	'treeMap2Cat2MeasureChartProp_colorPaletteLabel': 'Palettes de couleurs',
	'treeMap3Cat1MeasureChartProp_colorPaletteLabel': 'Palettes de couleurs',
	'treeMap3Cat2MeasureChartProp_colorPaletteLabel': 'Palettes de couleurs',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesLabel': 'Maintenir l\'échelle de l\'axe',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesDescription': 'Afficher toujours les valeurs minimales et maximales des axes.',
	'treeMap1Cat1MeasureChartProp_suppressZerosLabel': 'Masquer vide',
	'treeMap1Cat1MeasureChartProp_suppressZerosDescription': 'Masquer les catégories sans valeurs associées.',
	'treeMap1Cat1MeasureChartProp_hideLegendLabel': 'Masquer la légende',
	'treeMap1Cat1MeasureChartProp_hideLegendDescription': 'Masquer la légende.',
	'treeMap1Cat1MeasureChartProp_legendPositionLabel': 'Position de la légende',
	'wordChart1Cat1MeasureCaption': 'Nuage de mots',
	'wordChart1Cat1MeasureDataSlot_wordLabel': 'Mots',
	'wordChart1Cat1MeasureDataSlot_scaleLabel': 'Taille selon',
	'wordChart1Cat1MeasureProp_colorPaletteLabel': 'Palettes de couleurs',
	'wordChart1Cat1MeasureProp_elementColorLabel': 'Couleur des mots',
	'wordChart1Cat1MeasureProp_maintainAxisScalesLabel': 'Maintenir l\'échelle de l\'axe',
	'wordChart1Cat1MeasureProp_maintainAxisScalesDescription': 'Afficher toujours les valeurs minimales et maximales des axes.',
	'wordChart1Cat1MeasureProp_suppressZerosLabel': 'Masquer vide',
	'wordChart1Cat1MeasureProp_suppressZerosDescription': 'Masquer les catégories sans valeurs associées.',
	'missingDataSetData': 'Les données de cet ensemble de données ne sont pas disponibles. Actualisez l\'ensemble de données ou prenez contact avec votre administrateur pour accéder à la source.',
	'hideShowSummaries': 'Masquer/afficher les récapitulatifs',
	'crosstabName': 'Tableau croisé',
	'value_is_not_available': 'Non disponible',
	'swapRowsAndColumns': 'Permuter les lignes et les colonnes',
	'NoPinsCollected': 'Aucune visualisation épinglée',
	'pinSearchOld': 'Rechercher mes épingles',
	'pinDeletedToast': 'L\'épingle a été supprimée',
	'pinAddedToast': 'L\'épingle a été ajoutée à Mes épingles',
	'pinRetrieveError': 'Une ou plusieurs épingles ne peuvent pas être extraites. Réessayez ultérieurement.',
	'pinErrorTitle': 'Erreur d\'épinglage',
	'renamePinTooltip': 'Entrer un nom...',
	'renamePinInvalidText': 'Cette zone est obligatoire.',
	'pinRemove': 'Supprimer',
	'deletePin': 'Supprimer l\'épingle',
	'renamePin': 'Renommer',
	'cancelRenamePin': 'Annuler',
	'confirmRenamePin': 'Effectué',
	'dataset_time': 'time',
	'dataset_date': 'date',
	'dataset_location': 'emplacement',
	'dataset_number': 'nombre',
	'dataset_text': 'texte',
	'widgetConditionalFormatLabel': 'Activer/Désactiver les contrôles de formatage conditionnel',
	'deletePinConfirmationMessage': 'Voulez-vous vraiment supprimer cette épingle ? Cette opération est irréversible.',
	'deletePinConfirm': 'Confirmer la suppression',
	'pinDeleteError': 'Une ou plusieurs épingles ne peuvent pas être supprimées. Réessayez ultérieurement.',
	'metadataPickerTitle': 'Créer un ensemble de données',
	'moreTitle': 'Plus',
	'remove_slider_handle': 'Retirer la poignée',
	'missingFiltering': 'Colonne manquante :',
	'unSupportedPromptType': 'Le scénario avec invites n\'est pas pris en charge actuellement.',
	'preAggregateLabel': 'Appliquer les valeurs d\'invite de la source de données',
	'postAggregateLabel': 'Appliquer les valeurs d\'invite dans le rapport',
	'preAggregateText': 'La plage utilise les valeurs qui figurent dans la source de données et non les valeurs affichées dans le tableau de bord.',
	'tabName_general': 'Général', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visDetails': 'Détails',
	'tabName_textDetails': 'Détails du texte', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_mediaDetails': 'Détails du support', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_webDetails': 'Détails de la page Web', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_imageDetails': 'Détails de l\'image', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visualization': 'Visualisation',
	'sectionName_canvas': 'Structure',
	'sectionName_colorsAndThemes_v1': 'Couleur et thème',
	'sectionName_colorsAndThemes': 'Thème et arrière-plan',
	'colorsAndThemes_legacyWarning': 'Le tableau de bord actuel utilise un thème issu d\'une édition précédente. La modification du thème et la sauvegarde du tableau de bord supprime définitivement l\'accès aux palettes du thème précédent.',
	'sectionName_details': 'Détails',
	'sectionName_positionAndStyle': 'Position et style',
	'sectionName_appearance': 'Apparence', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_advanced': 'Avancé',
	'sectionName_layout': 'Présentation', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_tabs': 'Libellés d\'onglet',
	'sectionName_tabTitle': 'Libellé',
	'sectionName_tabBackground': 'Arrière-plan',
	'addDataSourceDialogTitle': 'Ajouter une source de données',
	'addDataSourceDialogButtonLabel': 'Ajouter',
	'shapesDoubleChevron': 'Double chevron',
	'widgetsPanelTitle': 'Widgets',
	'widgetsPanelBasicsTab': 'Bases',
	'widgetsPanelImageLibraryTab': 'Images',
	'widgetsPanelSectionStandard': 'Standard',
	'widgetsPanelSectionAdvanced': 'Avancé',
	'widgetsPanelSectionShapes': 'Formes',
	'customWidgetsTitle': 'Widgets personnalisés',
	'filterItemCanvasMove': 'Ajouter au canevas',
	'filterOverflowMenu_Global': 'Tous les onglets du menu déroulant dynamique',
	'filterOverflowMenu_Tab': 'Cet onglet du menu déroulant dynamique',
	'filterOverflowMenu_Item': 'Filtrer le menu déroulant dynamique',
	'filterOverflowMenu_Single': 'Menu déroulant dynamique',
	'filterItemEdit': 'Editer les valeurs de filtre',
	'filterDeleteAllItems': 'Supprimer tous les filtres',
	'filterClearAllItems': 'Effacer tous les filtres',
	'filterClearSelection': 'Effacer le filtre',
	'filterPlayerMode': 'Afficher le lecteur',
	'filterStaticMode': 'Afficher la liste',
	'filterInvertSelection': 'Inverser le filtre',
	'filterIconLabel_Global': 'Tous les onglets',
	'filterIconLabel_Single': 'Filtres',
	'filterIconLabel_Tab': 'Cet onglet',
	'filterIconTooltip_Global': 'Tous les onglets',
	'filterIconTooltip_Tab': 'Cet onglet',
	'filterIconTooltip_Single': 'Filtres',
	'filterItemDelete': 'Supprimer le filtre',
	'filterValueSeparator': ',',
	'filterRange': '%{from}-%{to}',
	'filterInvertRange': 'tout sauf : %{from} à %{to}',
	'filterExcept': 'sauf %{values}',
	'filterAll': 'Toutes',
	'filterBlank': '(blanc)',
	'filterDisableRangeInvert': 'Non disponible lorsque cette colonne est comprise dans le filtre "Tous les onglets".',
	'filterDisableHierarchyInvert': 'Non disponible lorsque cette colonne est un filtre de hiérarchie.',
	'filterSelectedOfTotal': '%{selected} sur %{totalMembers}',
	'filter_date_before': 'Avant %{to}',
	'filter_date_before_except': 'Pas avant %{to}',
	'filter_date_after': 'Après %{from}',
	'filter_date_after_except': 'Pas après %{from}',
	'filter_date_between': 'Entre %{from} et %{to}',
	'filter_date_between_except': 'Pas entre %{from} et %{to}',
	'filter_drag_and_drop_all_tabs': 'Glissez-déposez des données ici pour filtrer tous les onglets.',
	'filter_drag_and_drop_current_tab': 'Glissez-déposez des données ici pour filtrer cet onglet.',
	'filter_drag_and_drop_single_dock': 'Glissez-déposez des données ici pour filtrer.',
	'errMsgFilterItemGenericTitle': 'Impossible de charger les valeurs de filtre',
	'widgetChromeRotate': 'Pivoter',
	'toolbarRegionLabel': 'Barre d\'outils',
	'toolbarActionDelete': 'Supprimer',
	'toolbarActionGroup': 'Groupe',
	'toolbarActionUngroup': 'Dégrouper',
	'toolbarActionOrderToFront': 'Placer à l\'avant-plan',
	'toolbarActionOrderToBack': 'Placer à l\'arrière-plan',
	'toolbarActionEditTitle': 'Editer le titre',
	'toolbarActionWrapTitle': 'Encapsuler le titre',
	'toolbarActionPin': 'Collecter',
	'toolbarActionPinOld': 'Epingler',
	'toolbarActionAlign': 'Alignement',
	'alignWidgetLeft': 'A gauche',
	'alignWidgetCenter': 'Au centre',
	'alignWidgetRight': 'A droite',
	'alignWidgetTop': 'En haut',
	'alignWidgetMiddle': 'Milieu',
	'alignWidgetBottom': 'En bas',
	'distributeWidgetsVertical': 'Distribuer verticalement',
	'distributeWidgetsHoriz': 'Répartir horizontalement',
	'toolbarChangeVisualization': 'Changer de visualisation',
	'multipurposeHeader': 'Sélectionner un type de widget',
	'multipurposePlaceholderText': 'Sélectionner un des widgets pour commencer.',
	'live_label': 'Graphique',
	'filter_label': 'Filtre',
	'one_named_live': 'Graphique %{name}',
	'one_named_live_numbered': 'Graphique %{name} (%{number})',
	'one_unknown_live': 'Graphique',
	'one_unknown_live_numbered': 'Graphique (%{number})',
	'few_live': 'Groupe de %{count} graphiques',
	'many_live': 'Groupe de %{count} graphiques',
	'one_custom': 'Widget personnalisé',
	'one_custom_named': '%{name}',
	'one_custom_named_numbered': '%{name} (%{number})',
	'one_named_filter': 'Filtre %{name}',
	'one_named_filter_numbered': 'Filtre %{name} (%{number})',
	'one_unknown_filter': 'Filtre',
	'one_unknown_filter_numbered': 'Filtre (%{number})',
	'few_filter': 'Groupe de %{count} filtres',
	'many_filter': 'Groupe de %{count} filtres',
	'LIVE_bar_has_mapping': 'Graphique à barres %{values}',
	'LIVE_bar_has_mapping_numbered': 'Graphique à barres %{values} (%{number})',
	'LIVE_bar_opt_mapping': 'Graphique à barres %{categories} par %{values}',
	'LIVE_bar_opt_mapping_numbered': 'Graphique à barres %{categories} par %{values} (%{number})',
	'LIVE_bar_no_mapping': 'Graphique à barres vide',
	'LIVE_bar_no_mapping_numbered': 'Graphique à barres vide (%{number})',
	'LIVE_bar_named': 'Graphique à barres %{name}',
	'LIVE_bar_named_numbered': 'Graphique à barres %{name} (%{number})',
	'LIVE_stacked_bar_has_mapping': 'Graphique à barres empilées %{values}',
	'LIVE_stacked_bar_has_mapping_numbered': 'Graphique à barres empilées %{values} (%{number})',
	'LIVE_stacked_bar_opt_mapping': 'Graphique à barres empilées %{categories} par %{values}',
	'LIVE_stacked_bar_opt_mapping_numbered': 'Graphique à barres empilées %{categories} par %{values} (%{number})',
	'LIVE_stacked_bar_no_mapping': 'Graphique à barres empilées vide',
	'LIVE_stacked_bar_no_mapping_numbered': 'Graphique à barres empilées vide (%{number})',
	'LIVE_stacked_bar_named': 'Graphique à barres empilées %{name}',
	'LIVE_stacked_bar_named_numbered': 'Graphique à barres empilées %{name} (%{number})',
	'LIVE_bubble_has_mapping': 'Graphique à bulles %{categories} par %{x} et %{y}',
	'LIVE_bubble_has_mapping_numbered': 'Graphique à bulles %{categories} par %{x} et %{y} (%{number})',
	'LIVE_bubble_no_mapping': 'Graphique à bulles vide',
	'LIVE_bubble_no_mapping_numbered': 'Graphique à bulles vide (%{number})',
	'LIVE_bubble_named': 'Graphique à bulles %{name}',
	'LIVE_bubble_named_numbered': 'Graphique à bulles %{name} (%{number})',
	'LIVE_composite_has_mapping': 'Graphique composite %{categories} par %{columnValue} et %{lineValue}',
	'LIVE_composite_has_mapping_numbered': 'Graphique composite %{categories} par %{columnValue} et %{lineValue} (%{number})',
	'LIVE_composite_no_mapping': 'Graphique composite vide',
	'LIVE_composite_no_mapping_numbered': 'Graphique composite vide (%{number})',
	'LIVE_composite_named': 'Graphique composite %{name}',
	'LIVE_composite_named_numbered': 'Graphique composite %{name} (%{number})',
	'LIVE_decision_tree_has_mapping': 'Arbre de décisions %{values}',
	'LIVE_decision_tree_has_mapping_numbered': 'Arbre de décisions %{values} (%{number})',
	'LIVE_decision_tree_no_mapping': 'Arbre de décisions vide',
	'LIVE_decision_tree_no_mapping_numbered': 'Arbre de décisions vide (%{number})',
	'LIVE_decision_tree_named': 'Arbre de décisions %{name}',
	'LIVE_decision_tree_named_numbered': 'Arbre de décisions %{name} (%{number})',
	'LIVE_packed_bubble_has_mapping': 'Graphique à paquet de bulles %{categories}',
	'LIVE_packed_bubble_has_mapping_numbered': 'Graphique à paquet de bulles %{categories} (%{number})',
	'LIVE_packed_bubble_no_mapping': 'Graphique à paquet de bulles vide',
	'LIVE_packed_bubble_no_mapping_numbered': 'Graphique à paquet de bulles vide (%{number})',
	'LIVE_packed_bubble_named': 'Graphique à paquet de bulles %{name}',
	'LIVE_packed_bubble_named_numbered': 'Graphique à paquet de bulles %{name} (%{number})',
	'LIVE_pie_has_mapping': 'Graphique circulaire %{categories} par %{values}',
	'LIVE_pie_has_mapping_numbered': 'Graphique circulaire %{categories} par %{values} (%{number})',
	'LIVE_pie_no_mapping': 'Graphique circulaire vide',
	'LIVE_pie_no_mapping_numbered': 'Graphique circulaire vide (%{number})',
	'LIVE_pie_named': 'Graphique circulaire %{name}',
	'LIVE_pie_named_numbered': 'Graphique circulaire %{name} (%{number})',
	'LIVE_pie_as_donut_has_mapping': 'Graphique en anneau %{categories} par %{values}',
	'LIVE_pie_as_donut_has_mapping_numbered': 'Graphique en anneau %{categories} par %{values} (%{number})',
	'LIVE_pie_as_donut_no_mapping': 'Graphique en anneau vide',
	'LIVE_pie_as_donut_no_mapping_numbered': 'Graphique en anneau vide (%{number})',
	'LIVE_pie_as_donut_named': 'Graphique en anneau %{name}',
	'LIVE_pie_as_donut_named_numbered': 'Graphique en anneau %{name} (%{number})',
	'LIVE_line_has_mapping': 'Graphique à courbes %{categories} par %{values}',
	'LIVE_line_has_mapping_numbered': 'Graphique à courbes %{categories} par %{values} (%{number})',
	'LIVE_line_no_mapping': 'Graphique à courbes vide',
	'LIVE_line_no_mapping_numbered': 'Graphique à courbes vide (%{number})',
	'LIVE_line_named': 'Graphique à courbes %{name}',
	'LIVE_line_named_numbered': 'Graphique à courbes %{name} (%{number})',
	'LIVE_area_has_mapping': 'Graphique en aires %{categories} par %{values}',
	'LIVE_area_has_mapping_numbered': 'Graphique en aires %{categories} par %{values} (%{number})',
	'LIVE_area_no_mapping': 'Graphique en aires vide',
	'LIVE_area_no_mapping_numbered': 'Graphique en aires vide (%{number})',
	'LIVE_area_named': 'Graphique en aires %{name}',
	'LIVE_area_named_numbered': 'Graphique en aires %{name} (%{number})',
	'LIVE_area_as_stacked_percent_has_mapping': 'Graphique en aires de pourcentage empilées %{categories} par %{values}',
	'LIVE_area_as_stacked_percent_has_mapping_numbered': 'Graphique en aires de pourcentage empilées %{categories} par %{values} (%{number})',
	'LIVE_area_as_stacked_percent_no_mapping': 'Graphique en aires de pourcentage empilées vide',
	'LIVE_area_as_stacked_percent_no_mapping_numbered': 'Graphique en aires de pourcentage empilées vide (%{number})',
	'LIVE_area_as_stacked_percent_named': 'Graphique en aires de pourcentage empilées %{name}',
	'LIVE_area_as_stacked_percent_named_numbered': 'Graphique en aires de pourcentage empilées %{name} (%{number})',
	'LIVE_heatmap_has_mapping': 'Carte de densité %{color}',
	'LIVE_heatmap_has_mapping_numbered': 'Carte de densité %{color} (%{number})',
	'LIVE_heatmap_no_mapping': 'Carte de densité vide',
	'LIVE_heatmap_no_mapping_numbered': 'Carte de densité vide (%{number})',
	'LIVE_heatmap_named': 'Carte de densité %{name}',
	'LIVE_heatmap_named_numbered': 'Carte de densité %{name} (%{number})',
	'LIVE_network_opt_mapping': 'Réseau %{categories} par %{series} et %{values}',
	'LIVE_network_opt_mapping_numbered': 'Réseau %{categories} par %{series} et %{values} (%{number})',
	'LIVE_network_has_mapping': 'Réseau %{categories} par %{series}',
	'LIVE_network_has_mapping_numbered': 'Réseau %{categories} par %{series} (%{number})',
	'LIVE_network_no_mapping': 'Réseau vide',
	'LIVE_network_no_mapping_numbered': 'Réseau vide (%{number})',
	'LIVE_network_named': 'Réseau %{name}',
	'LIVE_network_named_numbered': 'Réseau %{name} (%{number})',
	'LIVE_radial_bar_opt_mapping': 'Graphique à barres radial %{categories} par %{values}',
	'LIVE_radial_bar_opt_mapping_numbered': 'Graphique à barres radial %{categories} par %{values} (%{number})',
	'LIVE_radial_bar_has_mapping': 'Graphique à barres radial %{values}',
	'LIVE_radial_bar_has_mapping_numbered': 'Graphique à barres radial %{values} (%{number})',
	'LIVE_radial_bar_no_mapping': 'Graphique à barres radial vide',
	'LIVE_radial_bar_no_mapping_numbered': 'Graphique à barres radial vide (%{number})',
	'LIVE_radial_bar_named': 'Graphique à barres radial %{name}',
	'LIVE_radial_bar_named_numbered': 'Graphique à barres radial %{name} (%{number})',
	'LIVE_spiral_has_mapping': 'Graphique en spirale %{values}',
	'LIVE_spiral_has_mapping_numbered': 'Graphique en spirale %{values} (%{number})',
	'LIVE_spiral_no_mapping': 'Graphique en spirale vide',
	'LIVE_spiral_no_mapping_numbered': 'Graphique en spirale vide (%{number})',
	'LIVE_spiral_named': 'Graphique en spirale %{name}',
	'LIVE_spiral_named_numbered': 'Graphique en spirale %{name} (%{number})',
	'LIVE_treemap_has_mapping': 'Carte d\'arborescence %{categories} par %{size}',
	'LIVE_treemap_has_mapping_numbered': 'Carte d\'arborescence %{categories} par %{size} (%{number})',
	'LIVE_treemap_no_mapping': 'Carte d\'arborescence vide',
	'LIVE_treemap_no_mapping_numbered': 'Carte d\'arborescence vide (%{number})',
	'LIVE_treemap_named': 'Carte d\'arborescence %{name}',
	'LIVE_treemap_named_numbered': 'Carte d\'arborescence %{name} (%{number})',
	'LIVE_wordcloud_has_mapping': 'Nuage de mots %{categories}',
	'LIVE_wordcloud_has_mapping_numbered': 'Nuage de mots %{categories} (%{number})',
	'LIVE_wordcloud_no_mapping': 'Nuage de mots vide',
	'LIVE_wordcloud_no_mapping_numbered': 'Nuage de mots vide (%{number})',
	'LIVE_wordcloud_named': 'Nuage de mots %{name}',
	'LIVE_wordcloud_named_numbered': 'Nuage de mots %{name} (%{number})',
	'LIVE_data_player_has_mapping': 'Lecteur de données %{category}',
	'LIVE_data_player_has_mapping_numbered': 'Lecteur de données %{category} (%{number})',
	'LIVE_data_player_no_mapping': 'Lecteur de données vide',
	'LIVE_data_player_no_mapping_numbered': 'Lecteur de données vide (%{number})',
	'LIVE_data_player_named': 'Lecteur de données %{name}',
	'LIVE_data_player_named_numbered': 'Lecteur de données %{name} (%{number})',
	'LIVE_map_has_mapping': 'Mappe %{locations}',
	'LIVE_map_has_mapping_numbered': 'Mappe %{locations} (%{number})',
	'LIVE_map_no_mapping': 'Carte vide',
	'LIVE_map_no_mapping_numbered': 'Mappe vide (%{number})',
	'LIVE_map_named': 'Mappe %{name}',
	'LIVE_map_named_numbered': 'Mappe %{name} (%{number})',
	'LIVE_point_has_mapping': 'Graphique à points %{categories} par %{values}',
	'LIVE_point_has_mapping_numbered': 'Graphique à points %{categories} par %{values} (%{number})',
	'LIVE_point_no_mapping': 'Graphique à points vide',
	'LIVE_point_no_mapping_numbered': 'Graphique à points vide (%{number})',
	'LIVE_point_named': 'Graphique à points %{name}',
	'LIVE_point_named_numbered': 'Graphique à points %{name} (%{number})',
	'LIVE_column_has_mapping': 'Graphique à colonnes %{values}',
	'LIVE_column_has_mapping_numbered': 'Graphique à colonnes %{values} (%{number})',
	'LIVE_column_opt_mapping': 'Graphique à colonnes %{categories} par %{values}',
	'LIVE_column_opt_mapping_numbered': 'Graphique à colonnes %{categories} par %{values} (%{number})',
	'LIVE_column_no_mapping': 'Graphique à colonnes vide',
	'LIVE_column_no_mapping_numbered': 'Graphique à colonnes vide (%{number})',
	'LIVE_column_named': 'Graphique à colonnes %{name}',
	'LIVE_column_named_numbered': 'Graphique à colonnes %{name} (%{number})',
	'LIVE_stacked_column_has_mapping': 'Graphique à colonnes empilées %{values}',
	'LIVE_stacked_column_has_mapping_numbered': 'Graphique à colonnes empilées %{values} (%{number})',
	'LIVE_stacked_column_opt_mapping': 'Graphique à colonnes empilées %{categories} par %{values}',
	'LIVE_stacked_column_opt_mapping_numbered': '%{categories} by %{values} stacked column chart (%{number})',
	'LIVE_stacked_column_no_mapping': 'Graphique à colonnes empilées vide',
	'LIVE_stacked_column_no_mapping_numbered': 'Graphique à colonnes empilées vide (%{number})',
	'LIVE_stacked_column_named': 'Graphique à colonnes empilées %{name}',
	'LIVE_stacked_column_named_numbered': 'Graphique à colonnes empilées %{name} (%{number})',
	'LIVE_scatter_opt_mapping': 'Nuage de points %{categories} par %{x} et %{y}',
	'LIVE_scatter_opt_mapping_numbered': 'Nuage de points %{categories} par %{x} et %{y} (%{number})',
	'LIVE_scatter_has_mapping': 'Nuage de points %{x} par rapport à %{y}',
	'LIVE_scatter_has_mapping_numbered': 'Nuage de points %{x} par rapport à %{y} (%{number})',
	'LIVE_scatter_no_mapping': 'Nuage de points vide',
	'LIVE_scatter_no_mapping_numbered': 'Nuage de points vide (%{number})',
	'LIVE_scatter_named': 'Nuage de points %{name}',
	'LIVE_scatter_named_numbered': 'Nuage de points %{name} (%{number})',
	'LIVE_waterfall_has_mapping': 'Graphique en cascade %{values}',
	'LIVE_waterfall_has_mapping_numbered': 'Graphique en cascade %{values} (%{number})',
	'LIVE_waterfall_no_mapping': 'Graphique en cascade vide',
	'LIVE_waterfall_no_mapping_numbered': 'Graphique en cascade vide (%{number})',
	'LIVE_waterfall_named': 'Graphique en cascade %{name}',
	'LIVE_waterfall_named_numbered': 'Graphique en cascade %{name} (%{number})',
	'LIVE_empty_visualization_hint_title': 'Générez votre visualisation',
	'LIVE_empty_visualization_hint_description': 'Glissez-déposez des colonnes ici ou sur les emplacements situés sur la gauche.',
	'LIVE_slots_required_field_description': '%{asterisk} Indique une zone requise',
	'LIVE_slots_drag_and_drop_description': 'Glissez-déposez des données sur les emplacements ci-dessus pour générer et filtrer la visualisation.',
	'requiredField': 'Zone requise',
	'fullScreenEnter': 'Passer en mode plein écran',
	'fullScreenClose': 'Quitter le mode plein écran',
	'noExtraText_multipurpose': 'Espace réservé multi-usage',
	'noExtraText_multipurpose_numbered': 'Espace réservé multi-usage (%{number})',
	'one_placeholder_vis': 'Emplacement réservé à la visualisation',
	'one_placeholder_vis_numbered': 'Emplacement réservé à la visualisation (%{number})',
	'one_placeholder_text': 'Emplacement réservé au texte',
	'one_placeholder_text_numbered': 'Emplacement réservé au texte (%{number})',
	'few_placeholder_text': 'Groupe de %{count} emplacements réservés au texte',
	'many_placeholder_text': 'Groupe de %{count} emplacements réservés au texte',
	'filter_includesAll': 'Tout inclure',
	'timeline_filter_moved_to': 'Filtre de délai %{id} déplacé à %{time}',
	'timelineSettingsButton': 'Options de lecture',
	'autoPlay': 'Lire toutes les scènes',
	'loop': 'Boucle',
	'noSceneTransitionLabel': 'Aucun',
	'sceneTransitionPropertyLabel': 'Transition de scène',
	'animatedPathSceneTransitionLabel': 'Chemin d\'accès animé',
	'sweepSceneTransitionLabel': 'Balayage',
	'propAniAnimation': 'Animation',
	'propAniTypeEntrance': 'Animation d\'entrée',
	'propAniDirectionIn': 'Direction d\'entrée',
	'propAniTypeExit': 'Animation de sortie',
	'propAniDirectionOut': 'Direction de sortie',
	'propAniDirection': 'Direction',
	'timelineAnimationProperties': 'Ouvrir les propriétés d\'animation',
	'editStoryCoachMarkTitle': 'Editer l\'histoire',
	'editStoryCoachMarkContents': 'Cliquez sur l\'icône Crayon pour éditer cette histoire.',
	'addDataStoryCoachMarkContents': 'Faites glisser des données du panneau des données jusqu\'à votre histoire.',
	'expandSceneCoachmarkTitle': 'Ouvrir le calendrier linéaire',
	'expandSceneCoachmarkContents': 'Animez une scène en ajustant la visibilité de l\'objet en fonction de l\'heure et de la durée.',
	'overviewCoachmarkTitle': 'Scènes de présentation',
	'overviewCoachmarkContents': 'Utilisez les scènes de présentation au début et à la fin de votre histoire pour afficher une vue d\'ensemble de toutes les scènes. Depuis une scène de présentation, cliquez sur une scène et faites-la glisser pour la permuter avec une autre scène. Vous pouvez afficher et masquer les scènes de présentation dans les propriétés de l\'histoire.',
	'animatedPathCoachmarkTitle': 'Chemin d\'accès animé',
	'animatedPathCoachmarkContents': 'Pour animer un objet d\'une scène à l\'autre, dupliquez une scène contenant un objet. Ensuite, déplacez, redimensionnez ou faites pivoter l\'objet dupliqué dans la nouvelle scène.',
	'tabName_animation': 'Animation',
	'textWidgetIconPlaceholderText': 'Cliquez pour ajouter du texte',
	'buildVisHeader': 'Créer une visualisation',
	'visIconPlaceholderText': 'Glisser-déposer des zones pour créer une visualisation',
	'launchNewExplore': 'Nouvelle exploration',
	'addTo': 'Ajouter à',
	'addToExisting': 'Ajouter à l\'existant...',
	'exploreData': 'Explorer',
	'explore_remove_widget_styles': 'Les propriétés de visualisation personnalisées, telles que les paramètres de couleur, ne seront pas conservées dans votre exploration.',
	'editNotebook': 'Editer le widget',
	'thumbnails_error_fetching': 'Erreur lors de la récupération des miniatures',
	'copy': '%{count} actif(s) copiés',
	'specConvertErr': 'Une erreur est survenue lors du collage ou de la conversion de la spécification de tableau de bord',
	'specCopyErr': 'Erreur lors de la copie de la spécification de tableau de bord',
	'pasteNotSupportedErr': 'Le collage depuis un élément %{name} n\'est pas pris en charge.',
	'reportParam': 'Rapport',
	'filterWidgetCopyWarn': 'La visualisation avec filtres n\'a pas été copiée car les filtres ne sont pas pris en charge actuellement.',
	'upgradingDashboard': 'Mise à niveau de "%{name}" pour %{version}...',
	'upgradeComplete': 'Mise à niveau terminée',
	'individualTabProperties': 'Propriétés de l\'onglet individuel',
	'propMasterTabStylesLabel_v1': 'Style d\'onglet global',
	'propMasterTabStylesLabel': 'Style de tous les onglets',
	'propTabPosition': 'Position de l\'onglet',
	'propTabTitle': 'Titre',
	'propTabBackgroundColor': 'Couleur de remplissage',
	'propTabTextColor': 'Couleur du titre',
	'propTabSelectedBarColor': 'Couleur de la barre sélectionnée',
	'propTabRestoreDefaults': 'Restaurer les valeurs par défaut',
	'propIndividualTabStylesLabel': 'Style de l\'onglet individuel',
	'propIndividualTabStylesAriaLabel': 'Ouvrir les propriétés de style de l\'onglet individuel',
	'propTabIconPosition': 'Position de l\'icône',
	'propLeftTitle': 'A gauche du titre',
	'propRightTitle': 'A droite du titre',
	'propTopTitle': 'Au-dessus du titre',
	'propBottomTitle': 'Au-dessous du titre',
	'propTabIconLabel': 'Visuel',
	'propTabIcon': 'Icône',
	'propTabIconColor': 'Couleur des icônes',
	'no_icon': 'Vide',
	'announcement': 'Annonce',
	'api': 'API',
	'archive': 'Archiver',
	'asset': 'Actif',
	'attachment': 'Pièce jointe',
	'audio': 'Audio',
	'bee': 'Bee',
	'blog': 'Blogue',
	'bookmark': 'Signet',
	'calendar': 'Calendrier',
	'camera': 'Caméra',
	'capability': 'Fonction',
	'catalog': 'Catalogue',
	'chat_message': 'Message de discussion',
	'checkout_cart': 'Panier de commande',
	'client': 'Client',
	'clock': 'Horloge',
	'cloud': 'Nuage',
	'code': 'Code',
	'data_quality': 'Qualité des données',
	'folder': 'Dossiers',
	'forum': 'Forum',
	'glasses': 'Lunettes',
	'group': 'Groupe',
	'hat': 'Chapeau',
	'headphone': 'Casque',
	'hills': 'Hills',
	'home': 'Accueil',
	'idea': 'Idée',
	'image': 'Image',
	'inventory': 'Inventaire',
	'like': 'Similaire',
	'link': 'Lien',
	'location': 'Emplacement',
	'manage': 'Gérer',
	'pen': 'Crayon',
	'mobile_phone': 'Téléphone mobile',
	'music': 'Musique',
	'notifications': 'Notifications',
	'paint': 'Peinture',
	'payment': 'Conditions de paiement',
	'password_key': 'Clé de mot de passe',
	'people': 'Personnes',
	'person': 'Personne',
	'phone': 'Téléphone',
	'pin': 'Epingler',
	'print': 'Imprimer',
	'recording': 'Enregistrement',
	'repository': 'Référentiel',
	'role': 'Rôle',
	'search': 'Rechercher',
	'properties': 'Propriétés',
	'speaker': 'Orateur',
	'star': 'Etoile',
	'tag': 'Balise',
	'thumbs_up': 'Pouces vers le haut',
	'thumbs_down': 'Pouces vers le bas',
	'tools': 'Outils',
	'traffic': 'Trafic',
	'trash': 'Corbeille',
	'twitter': 'Twitter',
	'unknown': 'Inconnu',
	'user': 'Utilisateur',
	'venn_diagram': 'Diagramme de Venn',
	'video': 'Vidéo',
	'view': 'Vue',
	'warning': 'Avertissement',
	'watch': 'Regarder',
	'watson': 'Watson',
	'wikis': 'Wikis',
	'workspace': 'Espace de travail',
	'world': 'Monde',
	'eventGroupButtonLabel': 'Afficher les connexions de widget',
	'dockToolbar': 'Verrouiller la barre d\'outils',
	'undockToolbar': 'Déverrouiller la barre d\'outils',
	'propShowTitle': 'Afficher le titre',
	'textAutoFontSize': 'Auto',
	'zoomFitToWidth': 'Ajuster à la largeur',
	'zoomWholePage': 'Ajuster à la page',
	'defaultZoomValue': 'Valeur par défaut du zoom',
	'zoomCategoryLabel': 'Zoom de page (agencement absolu uniquement)'
});
